<template>
<div>
  <br>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card class="mx-auto" max-width="344">
          <v-card-text>
            <div>Your Public IP Address is</div>
            <p class="display-1 text--primary">{{ip}}</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
  </div>
</template>
<script>
var ip = require("what-is-my-ip-address");
export default {
  data() {
    return {
      ip: ""
    };
  },
  created() {
    ip.v4().then(ip => {
      this.ip = ip;
    });
    document.title = "What is my IP - Encodify";
  }
};
</script>